import React from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import MarkdownRenderer from "components/Widgets/MarkdownRenderer";

export default function ToolTip({
  id,
  content,
  place = "bottom",
  delayShow = 800,
}) {
  return (
    <>
      <Tooltip
        id={id}
        content={
          <div
            className="text-wrap"
            style={{
              fontSize: "12px",
              lineHeight: "1.5",
              color: "#fff",
              borderRadius: "5px",
              maxWidth: "300px",
              margin: "0",
              padding: "0",
            }}
          >
            <MarkdownRenderer markdown={content} />
          </div>
        }
        place={place}
        delayShow={delayShow}
        style={{ zIndex: 9999 }}
      />
    </>
  );
}
